"use client";

import { useEffect, useRef, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function YourEquipmentSolutionStartsHere() {
  const [scrollY, setScrollY] = useState(0);
  const [hasAnimated, setHasAnimated] = useState(false);
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    if (ctaVisible && !hasAnimated) {
      setHasAnimated(true);
    }
  }, [ctaVisible, hasAnimated]);
  const parallaxOffset = scrollY * 0.5;
  return <section className="relative h-screen w-full overflow-hidden bg-dark-background">
      {}
      <div className="absolute inset-0 bg-cover bg-center transition-transform duration-75 ease-linear" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1417410/img/heavy_equipment_motion_hero.png)",
      transform: `translateY(${parallaxOffset}px) scale(1.1)`
    }}>
        {}
        <div className="group absolute inset-0">
          <div className="absolute inset-0 bg-cover bg-center transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] group-hover:scale-[1.02]" style={{
          backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1417410/img/heavy_equipment_motion_hero.png)"
        }} />
          {}
          <div className="absolute inset-0 opacity-0 transition-opacity duration-[var(--duration-slow)] group-hover:opacity-100">
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-[1200ms] ease-[var(--ease-smooth)]" />
          </div>
        </div>

        {}
        <div className="absolute inset-0 bg-gradient-to-b from-dark-background/60 via-dark-background/40 to-dark-background/80" />
      </div>

      {}
      <div className="relative z-10 flex h-full items-center justify-center px-4">
        <div className="glass-effect max-w-3xl w-full p-8 md:p-12 animate-fade-in-up" style={{
        animationDelay: "200ms"
      }}>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold text-foreground-light mb-4 leading-tight">
            Su Solución de Equipamiento Comienza Aquí
          </h1>
          <p className="text-lg md:text-xl text-foreground-light/90 mb-8 leading-relaxed">
            ProMáquinas ofrece soluciones integrales de construcción y minería con la maquinaria pesada, camiones y equipos más confiables de Chile: ventas y alquileres respaldados por soporte de expertos.
          </p>

          {}
          <div ref={ctaRef}>
            <Link to="/IndustrySolutionsPage">
              <Button size="lg" className={`btn-primary group ${hasAnimated ? "animate-pulse" : ""}`} style={{
              animationIterationCount: hasAnimated ? "1" : "infinite",
              animationDuration: "1.5s"
            }}>
                Explorar Soluciones
                <ArrowRight className="transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:translate-x-1" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}